import { api } from '@/lib/api';
import { saveBlob } from '@/lib/native';

/** GET a file from the API and save it. Errors come back as a readable message, even though the body was asked for as a blob. */
export async function saveFromApi(url: string, fallbackName: string): Promise<void> {
  try {
    const res = await api.get(url, { responseType: 'blob' });
    const cd = String(res.headers?.['content-disposition'] ?? '');
    const name = /filename="?([^";]+)"?/i.exec(cd)?.[1] ?? fallbackName;
    await saveBlob(res.data as Blob, name);
  } catch (e: any) {
    const blob = e?.response?.data;
    let message = 'Could not download the file. Please try again.';
    if (blob instanceof Blob) {
      try { message = JSON.parse(await blob.text())?.message ?? message; } catch { /* not JSON */ }
    }
    throw new Error(message);
  }
}
